module.exports = __webpack_public_path__ + "static/media/penEdit.a4ebdff4.svg";